angular.module('lsnBase.autocompleters', [
  'lsnBase.availability'
]);